import state from '@/store/module_telegram/state'
import mutations from '@/store/module_telegram/mutations'
import actions from '@/store/module_telegram/actions'

export default ({
  state,
  mutations,
  actions,
})